import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  user-select: none;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`
